<template>
  <div>
    <el-row>
      <el-col>
        <h4 style="text-align: left; margin-left: 20px">
          <i class="el-icon-s-management"></i>&nbsp;&nbsp; 提交
        </h4></el-col
      >
      <el-col style="text-align: left">
        <h1 style="text-align: left; margin-left: 20px">声明</h1>
        <ul style="list-style: none">
          <li>
            本人声明提交的所有资料均由本人填写，一切信息属实且未经修改，不存在任何造假或抄袭等行为。
          </li>

          <br />
          <li>
            本人了解实验语言学编辑部将对所提交的材料严格保密，不作商业用途。本人的申请材料一旦提交，不得撤回。
          </li>
          <br />
          <br />
        </ul>
      </el-col>
    </el-row>
    <el-row></el-row>
    <br />
    <el-col style="text-align: left; margin-left: 20px">
      <el-button
        style="
          background-color: #054a48;
          color: white;
          width: 150px;
          border: none;
        "
        @click="submitManuscript()"
        v-loading.fullscreen.lock="fullscreenLoading"
        >确认并提交</el-button
      >
    </el-col>
  </div>
</template>

<script>
import { addManuscripts, findManuscriptByContributorEmail } from '@/api/data'
export default {
  name: 'SubmitButtonComponent',
  data () {
    return {
      userInfo: null,
      fullscreenLoading: false
    }
  },
  methods: {
    submitManuscript () {
      this.fullscreenLoading = true
      addManuscripts({
        key: this.userInfo.email
      }).then((res) => {
        if (res.data.errorMessage === '没毛病') {
          this.$message({
            message: '投递成功',
            type: 'success'
          })
          this.fullscreenLoading = false
          const back = this
          back.$router.push({ name: 'manuscriptList' })
          console.log('投递成功')
        } else if (res.data.errorMessage === '空指针异常') {
          this.$message({
            message: '投递失败,请检查投递信息是否完整',
            type: 'error'
          })
          this.fullscreenLoading = false
        }
      })
    }
  },
  mounted () {
    let userInfo = this.$cookie.getCookie('userInfo')
    // if (userInfo == null || userInfo.type != "投稿人") {
    //   this.$message({
    //     message: "请先登录！",
    //     type: "error",
    //   });
    //   this.$router.push("index");
    // }
    this.userInfo = userInfo
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
</style>



// WEBPACK FOOTER //
// src/components/submitButtonComponent.vue